import { Trans } from "react-i18next";
import { LinkButton, type LinkButtonProps } from "../Link";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

export const UndoButton = (props: Omit<LinkButtonProps, "iconBefore" | "children">) => (
  <LinkButton iconBefore={<RestartAltIcon  />} {...props}>
    <Trans i18nKey={"common.undo"} />
  </LinkButton>
);
